import React from 'react';
import '../css/ScreeningNameNotice.css';

export default function ScreeningPendingSubject({ subject, onRun, disabled, loading, readOnly }) {
  return <div className="screeningNameCard" data-screening-state={loading ? 'running' : 'not-started'} aria-busy={!!loading}>
    <div className="screeningNameCardHeader">
      <div><strong>{subject.name}</strong><div className="text-muted small">{subject.roles.join(' · ')}</div></div>
      <span className="screeningPendingBadge">{loading ? 'Screening' : 'Not screened'}</span>
    </div>
    <div className="text-muted small">{loading ? 'Screening this subject for potential matches…' : 'Screening has not been run for this subject. Run screening to check for potential matches.'}</div>
    {!readOnly && onRun && <button type="button" className="btn btn-sm btn-outline-secondary mt-3"
      disabled={disabled || loading} onClick={onRun} aria-label={`Run screening for ${subject.name}`}>
      <i className={`bi ${loading ? 'bi-hourglass-split' : 'bi-arrow-repeat'} me-2`} aria-hidden="true" />
      {loading ? 'Screening…' : 'Run screening'}
    </button>}
  </div>;
}
